"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UniV2LikeAddLiquidityRecipe = void 0;
const uni_v2_like_sdk_1 = require("../../../api/uni-v2-like/uni-v2-like-sdk");
const approve_erc20_spender_step_1 = require("../../../steps/token/erc20/approve-erc20-spender-step");
const uni_v2_like_add_liquidity_step_1 = require("../../../steps/liquidity/uni-v2-like/uni-v2-like-add-liquidity-step");
const add_liquidity_recipe_1 = require("../add-liquidity-recipe");
const filters_1 = require("../../../utils/filters");
const fee_1 = require("../../../utils/fee");
const min_gas_limits_1 = require("../../../models/min-gas-limits");
class UniV2LikeAddLiquidityRecipe extends add_liquidity_recipe_1.AddLiquidityRecipe {
    constructor(uniswapV2Fork, erc20InfoA, erc20InfoB, slippageBasisPoints, provider) {
        super();
        this.config = {
            name: '[Name] Add Liquidity',
            description: 'Adds liquidity to a [Name] Pool.',
            minGasLimit: min_gas_limits_1.MIN_GAS_LIMIT_LP_V2_ADD_LIQUIDITY,
        };
        this.uniswapV2Fork = uniswapV2Fork;
        this.erc20InfoA = erc20InfoA;
        this.erc20InfoB = erc20InfoB;
        this.slippageBasisPoints = slippageBasisPoints;
        this.provider = provider;
        const forkName = uni_v2_like_sdk_1.UniV2LikeSDK.getForkName(uniswapV2Fork);
        this.config.name = `${forkName} Add Liquidity`;
        this.config.description = `Adds liquidity to a ${forkName} Pool.`;
    }
    supportsNetwork(networkName) {
        return uni_v2_like_sdk_1.UniV2LikeSDK.supportsForkAndNetwork(this.uniswapV2Fork, networkName);
    }
    async getAddLiquidityData(networkName, erc20AmountA) {
        this.addLiquidityData = await uni_v2_like_sdk_1.UniV2LikeSDK.getAddLiquidityData(this.uniswapV2Fork, networkName, erc20AmountA, this.erc20InfoB, this.slippageBasisPoints, this.provider);
        return this.addLiquidityData;
    }
    async getAddLiquidityAmountBForUnshield(networkName, targetUnshieldERC20AmountA) {
        const unshieldedAmountA = (0, fee_1.getUnshieldedAmountAfterFee)(networkName, targetUnshieldERC20AmountA.amount);
        const unshieldedERC20AmountA = {
            ...targetUnshieldERC20AmountA,
            amount: unshieldedAmountA,
        };
        this.addLiquidityData = await this.getAddLiquidityData(networkName, unshieldedERC20AmountA);
        const preUnshieldAmountB = (0, fee_1.getAmountToUnshieldForTarget)(networkName, this.addLiquidityData.erc20AmountB.amount);
        const erc20UnshieldAmountB = {
            ...this.addLiquidityData.erc20AmountB,
            amount: preUnshieldAmountB,
        };
        return {
            erc20UnshieldAmountB,
            addLiquidityData: this.addLiquidityData,
        };
    }
    async getInternalSteps(firstInternalStepInput) {
        const { networkName, erc20Amounts } = firstInternalStepInput;
        const erc20AmountA = (0, filters_1.findFirstInputERC20Amount)(erc20Amounts, this.erc20InfoA);
        this.addLiquidityData = await this.getAddLiquidityData(networkName, erc20AmountA);
        return [
            new approve_erc20_spender_step_1.ApproveERC20SpenderStep(this.addLiquidityData.routerContractAddress, this.erc20InfoA),
            new approve_erc20_spender_step_1.ApproveERC20SpenderStep(this.addLiquidityData.routerContractAddress, this.erc20InfoB),
            new uni_v2_like_add_liquidity_step_1.UniV2LikeAddLiquidityStep(this.uniswapV2Fork, this.addLiquidityData),
        ];
    }
}
exports.UniV2LikeAddLiquidityRecipe = UniV2LikeAddLiquidityRecipe;
